import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalSettingsNavigationTabsComponent } from './global-settings-navigation-tabs/global-settings-navigation-tabs.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { UIRouterModule } from '@uirouter/angular';
import { GlobalSettingsStates } from '@fi-app/global-settings/global-settings-states';
import { GlobalSettingsService } from '@fi-app/global-settings/global-settings.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        UtilitiesModule,
        UIRouterModule.forChild(GlobalSettingsStates),
        MatIconModule,
        MatButtonModule,
    ],
    declarations: [GlobalSettingsNavigationTabsComponent],
    providers: [GlobalSettingsService],
})
export class GlobalSettingsModule {}
